<template>
    <!-- 圣杯布局 -->
    <!-- 顶部 -->
    <header class="containerHeader">
        <div class="leftRightHeader"></div>

        <div class="centerHeader">
            <div class="flex-between">
                <!--  @click="$router.push('/')" -->
                <!--  @click="handleNavigation" -->
                <div class="flex_items">
    				<el-image :src="imageSrc" class="logo_style"></el-image>
                </div>
    			<div>
    				<el-menu :default-active="$route.path" router mode="horizontal" active-text-color="#0A87CD">
    					<el-menu-item index="/" class="menu-item">首页</el-menu-item>
    					<el-menu-item index="/products" class="menu-item">产品</el-menu-item>
    					<el-menu-item index="/solution" class="menu-item">解决方案</el-menu-item>
    					<el-menu-item index="/about" class="menu-item">关于我们</el-menu-item>
    					<el-menu-item index="/services" class="menu-item">服务支持</el-menu-item>
    				</el-menu>
    			</div>
            </div>
        </div>		

        <div class="leftRightHeader"></div>
    </header>
</template>

<script>
export default {
    data() {
        return {
			imageSrc: require('@/assets/zylogo.svg'),
        }
    },
	created() {
		
	},
    methods: {
        // 判断是否重复点击
		async handleNavigation() {
            try {
                await this.$router.push('/');
            } catch (error) {
                // 处理导航重复错误
                if (error.name !== 'NavigationDuplicated') {
                    throw error;
                }
            }
        }
	},
}
</script>

<style  lang="scss" scoped>
.containerHeader{
    display: flex;
    flex-direction: row;
    flex: 1;
    border-bottom: 1px solid #e6e6e6;
	width: 100%;
	height: 60px;
	line-height: 60px;
	background-color: white;
	
}
.leftRightHeader{
    flex: 1;
    height: 60px;
}
.centerHeader{
    flex: 0 0 1200px;
    height: 60px;
}
.logo_style {
	// width: 150px;
	height: 32px;
	// cursor: pointer;
}
.menu-item {
    font-weight: bold;
}
</style>

<style scoped>
.el-menu--horizontal>.el-menu-item.is-active, .el-menu--horizontal>.el-menu-item {
	border-bottom: none;
}
</style>